import React from 'react';
import { createRoot } from 'react-dom/client'; // Import from "react-dom/client"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Use createRoot from "react-dom/client"
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
